module.exports = __webpack_public_path__ + "static/img/12.5480631.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/zh/12.png
// module id = fPS9
// module chunks = 0